import React, { useState, useLayoutEffect } from 'react';
import { Col, Container, Row, Image } from 'react-bootstrap';
import './Proyectos.css';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import NavBar from '../../components/NavBar/NavBar';
import Boton from '../../components/Button/Button';
import Footer from '../../components/Footer/Footer';
import { NavLink } from 'react-router-dom';
import github from '../../Assets/github.png';
import Westudio from '../../Assets/wesetudio.png';
import caiUno from '../../Assets/proyectos/caiDos.png';
import saludUno from '../../Assets/proyectos/redUno.png';
import galacticaUno from '../../Assets/proyectos/galacticaPro.png';
import randomUno from '../../Assets/proyectos/juegoUno.png';

const Proyectos = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  const [showGalacticaRandom, setShowGalacticaRandom] = useState(false);

  const toggleGalacticaRandom = () => {
    setShowGalacticaRandom(!showGalacticaRandom);
  };

  return (
    <Container className="projecCont">
      <Row className="containerImg">
        <Row className="containerUnPro">
          <Col className="imgOrden">
            <Image src={caiUno} className="imgPro" />
          </Col>
          <Col className="textosPro">
            <Col className="contProTex">
              <h2 className="titlePro">CAI Ventures</h2>
              <p className="textPro">
                {t('In this project, I was tasked with leading the development team, providing JavaScript and React support to my teammates. Additionally, I held regular meetings with my Project Manager and the client to iteratively present the product´s value.')}
              </p>
              <Col className='contBt'>
              <NavLink to="https://www.caiventuresconsultoria.com/" target="_blank" className="btnTake" rel="noopener noreferrer">
                <Boton title={t('TAKE A LOOK')} />
              </NavLink>
              <NavLink className="gitUno" to="https://github.com/MariaBelenCaporale/cai-ventures-consultoria" target="_blank">
                <Image src={github} fluid />
                <p className="textGit">{t('Check Code')}</p>
              </NavLink>
              </Col>
            </Col>
          </Col>
        </Row>

        <Row className="containerUnProRev">  
          <Col className="textosPro">
            <Col className="contProTex">
              <h2 className="titlePro">WëStudio</h2>
              <p className="textPro">
                {t('Development of a responsive website for a design and communication agency. I took charge of designing the entire UI, and the landing page was developed using React js Vite')}
              </p>
              <Col className='contBt'>
              <NavLink to="https://www.teamwestudio.com/" target="_blank" className="btnTake" rel="noopener noreferrer">
                <Boton title={t('TAKE A LOOK')} />
              </NavLink>
              {/* <NavLink className="gitUno" to="https://github.com/MariaBelenCaporale/EnREDando.git" target="_blank">
                <Image src={github} fluid />
                <p className="textGit">{t('Check Code')}</p>
              </NavLink> */}
              </Col>
            </Col>
          </Col>
          <Col className="imgOrden">
            <Image src={Westudio} className="imgPro" />
          </Col>
        </Row>

        {/* <Row className="containerUnProRev">  
          <Col className="textosPro">
            <Col className="contProTex">
              <h2 className="titlePro">EnREDando Salud</h2>
              <p className="textPro">
                {t('This was a client project, carried out as a team effort. It included three User Experience (UX) designers, one community manager, and myself as the developer.')}
              </p>
              <Col className='contBt'>
              <NavLink to="https://enredando.vercel.app/" target="_blank" className="btnTake" rel="noopener noreferrer">
                <Boton title={t('TAKE A LOOK')} />
              </NavLink>
              <NavLink className="gitUno" to="https://github.com/MariaBelenCaporale/EnREDando.git" target="_blank">
                <Image src={github} fluid />
                <p className="textGit">{t('Check Code')}</p>
              </NavLink>
              </Col>
            </Col>
          </Col>
          <Col className="imgOrden">
            <Image src={saludUno} className="imgPro" />
          </Col>
        </Row> */}




        

        

       

        {showGalacticaRandom && (
          <>
          
          <Row className="containerUnPro">
          <Col className="imgOrden">
            <Image src={galacticaUno} className="imgPro" />
          </Col>
          <Col className="textosPro">
            <Col className="contProTex">
              <h2 className="titlePro">Galáctica</h2>
              <p className="textPro">
              {t('This project was developed using React JS. The goal was to create an e-commerce website, so I decided to let my imagination run wild and allow users to have fun while making their purchases.')}
              </p>
              <Col className='contBt'>
              <NavLink to="https://e-commerce-caporale.vercel.app/" target="_blank" className="btnTake" rel="noopener noreferrer">
                <Boton title={t('TAKE A LOOK')} />
              </NavLink>
              <NavLink className="gitUno" to="https://github.com/MariaBelenCaporale/eCommerce-Caporale.git" target="_blank">
                <Image src={github} fluid />
                <p className="textGit">{t('Check Code')}</p>
              </NavLink>
              </Col>
            </Col>
          </Col>
        </Row>


        <Row className="containerUnProRev">  
          <Col className="textosPro">
            <Col className="contProTex">
              <h2 className="titlePro">Random</h2>
              <p className="textPro">
              {t('During the JavaScript course, we were given the freedom to choose what to do. In my case, I created a website where the user can choose to play "Random Questions" or the classic "Rock, Paper, Scissors.')}
              </p>
              <Col className='contBt'>
              <NavLink to="https://random-jueguitos.vercel.app/" target="_blank" className="btnTake" rel="noopener noreferrer">
                <Boton title={t('TAKE A LOOK')} />
              </NavLink>
              <NavLink className="gitUno" to="https://github.com/MariaBelenCaporale/Random-jueguitos.git" target="_blank">
                <Image src={github} fluid />
                <p className="textGit">{t('Check Code')}</p>
              </NavLink>
              </Col>
            </Col>
          </Col>
          <Col className="imgOrden">
            <Image src={randomUno} className="imgPro" />
          </Col>
        </Row>

        <Row className="containerUnPro">
          <Col className="imgOrden">
            <Image src={saludUno} className="imgPro" />
          </Col>
          <Col className="textosPro">
            <Col className="contProTex">
              <h2 className="titlePro">EnREDando Salud</h2>
              <p className="textPro">
              {t('This was a client project, carried out as a team effort. It included three User Experience (UX) designers, one community manager, and myself as the developer.')}
              </p>
              <Col className='contBt'>
              <NavLink to="https://enredando.vercel.app/" target="_blank" className="btnTake" rel="noopener noreferrer">
                <Boton title={t('TAKE A LOOK')} />
              </NavLink>
              <NavLink className="gitUno" to="https://github.com/MariaBelenCaporale/EnREDando.git" target="_blank">
                <Image src={github} fluid />
                <p className="textGit">{t('Check Code')}</p>
              </NavLink>
              </Col>
            </Col>
          </Col>
        </Row>
            
          </>
        )}

        <button className="verMasButton" onClick={toggleGalacticaRandom}>
          {showGalacticaRandom ? t('See less') : t('See more')}
        </button>
      </Row>
    </Container>
  );
};

export default Proyectos;
